import axios from 'axios'
import qs from 'qs'
// import Router from '@/router/index';
// import api from '@/api/api.js';

const service = axios.create({
  // baseURL: '/api',
  timeout: 10000 // 请求超时时间
})
service.defaults.headers['Accept'] = 'application/json, text/plain, */*'
// service.defaults.headers["version"] = "2";
service.defaults.withCredentials = false // 允许携带cookies

// 添加请求拦截器
service.interceptors.request.use(config => {
  return config
}, error => {
  return Promise.reject(error)
})
// 正常请求-添加回响应拦截器
service.interceptors.response.use(response => {
  return response
}, error => {
  let msg = '服务器出错'
  // error.response.msg = '服务器出错'
  if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
    msg = '服务器超时'
    // return Promise.reject(error)
  }
  return Promise.reject(msg)
})

const HttpUtils = {
  /**
   * 封装get方法
   * @param url
   * @param data
   * @returns {Promise}
   */
  get (url, params = {}) {
    return new Promise((resolve, reject) => {
      service.get(url, {params: params}).then(response => {
        resolve(response.data)
      }).catch(err => {
        reject(err)
      })
    })
  },

  /**
   * form
   */
  form (url, data = {}, header = {}) {
    return new Promise((resolve, reject) => {
      service.post(url, data, {headers: header}).then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
    })
  },

  /**
   * 封装post请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  post (url, data = {}) {
    return new Promise((resolve, reject) => {
      service.post(url, data).then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
    })
  },
  /**
   * 封装post请求 FormData方式
   * @param url
   * @param data
   * @returns {Promise}
   */
  postform (url, data = {}) {
    return new Promise((resolve, reject) => {
      service.post(url, qs.stringify(data), {headers: {'content-type': 'application/x-www-form-urlencoded'}}).then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
    })
  },
  FormData (url, data = {}) {
    return new Promise((resolve, reject) => {
      service.post(url, data, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
    })
  },
  /**
   * 封装put请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  put (url, data = {}) {
    service.defaults.headers['method_name'] = 'put'
    return new Promise((resolve, reject) => {
      service.put(url, qs.stringify(data), {headers: {'content-type': 'application/x-www-form-urlencoded'}}).then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
    })
  },
  /**
   * 封装patch请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  patch (url, data = {}) {
    return new Promise((resolve, reject) => {
      service.patch(url, qs.stringify(data), {headers: {'content-type': 'application/x-www-form-urlencoded'}}).then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
    })
  },
  /**
   * 封装DELETE请求
   * @param url
   * @param data
   * @returns {Promise}
   */
  delete (url, data = {}) {
    return new Promise((resolve, reject) => {
      service.delete(url, qs.stringify(data), {headers: {'content-type': 'application/x-www-form-urlencoded'}}).then(response => {
        resolve(response)
      }, err => {
        reject(err)
      })
    })
  }
}

export default HttpUtils



// WEBPACK FOOTER //
// ./src/http/httpUtils.js